import { useProtected } from "@/hooks";
import { Outlet } from "react-router-dom";

export const AgendaTemplatesRoot = () => {
  useProtected();

  return <Outlet />;
};
